import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 7;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'budget-summary',
      title: `Budget Summary <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'When you click a budget, you\'ll first see this summary view with charts showing your income, expenses, and breakdowns by account, fund, and label. Click "Edit Budget" to open the editor.',
      attachTo: { element: '[data-tour="budget-summary"]', on: 'top' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'budget-overview',
      title: `Budget Builder <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'This is your budget grid. Each row is an account, and columns change depending on your view — funds, labels, or monthly detail.',
      attachTo: { element: '[data-tour="budget-table"]', on: 'top' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'budget-drawer-btn',
      title: `Budget Tools <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Open the tools panel to configure fund budgeting mode, label budgeting, populate from historical data, and view your budget summary.',
      attachTo: { element: '[data-tour="budget-drawer-btn"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Open Drawer',
          classes: 't3-shepherd-next-btn',
          action() {
            // Click the drawer button to open it
            const btn = document.querySelector('[data-tour="budget-drawer-btn"]');
            if (btn) btn.click();
            // Small delay to let drawer animate open
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'budget-drawer-mode',
      title: `Fund Budgeting Mode <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: '<strong>Top-Down:</strong> Set account totals first, then allocate to funds. Great for organizations with a fixed budget.<br/><br/><strong>Bottom-Up:</strong> Enter per-fund amounts and account totals calculate automatically. Good when each fund has its own budget.',
      attachTo: { element: '[data-tour="budget-drawer-mode"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'budget-drawer-history',
      title: `Historical Data <span class="t3-shepherd-step-count">${stepCounter(5)}</span>`,
      text: 'Quickly populate your budget from last year\'s actual income/expenses or last year\'s budget as a starting point.',
      attachTo: { element: '[data-tour="budget-drawer-history"]', on: 'left' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Close Drawer',
          classes: 't3-shepherd-next-btn',
          action() {
            const closeBtn = document.querySelector('[data-tour="budget-drawer-close"]');
            if (closeBtn) closeBtn.click();
            setTimeout(() => this.next(), 300);
          },
        },
      ],
    },
    {
      id: 'budget-breadcrumb',
      title: `Navigation & Allocation <span class="t3-shepherd-step-count">${stepCounter(6)}</span>`,
      text: 'The breadcrumb shows where you are (Budget > Fund > Label). The allocation bar tracks how much of the budget is assigned. Click fund column headers to drill into monthly detail.',
      attachTo: { element: '[data-tour="budget-breadcrumb"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'budget-back-btn',
      title: `Back Button <span class="t3-shepherd-step-count">${stepCounter(7)}</span>`,
      text: 'This button changes as you drill in — "Back to Funds", "Back to Labels", or "Back to Budgets". It always takes you up one level.',
      attachTo: { element: '[data-tour="budget-back-btn"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'budgets',
  pathPattern: '/foundation/budgets',
  getSteps,
  label: 'Budget Builder Tour',
});
